export default __webpack_public_path__ + "static/step-8883fef17d07091e0bdd460021b50c06.svg";